import React from "react";
import styled from "styled-components";

import { mobile } from "../../themes/responsive";
import html_blk from "../../assets/logos_svg/html_black.svg";
import html_wht from "../../assets/logos_svg/html_white.svg";
import css_blk from "../../assets/logos_svg/css_black.svg";
import css_wht from "../../assets/logos_svg/css_white.svg";
import js_blk from "../../assets/logos_svg/js_black.svg";
import js_wht from "../../assets/logos_svg/js_white.svg";
import react_blk from "../../assets/logos_svg/react_black.svg";
import react_wht from "../../assets/logos_svg/react_white.svg";
import node_blk from "../../assets/logos_svg/node_black.svg";
import node_wht from "../../assets/logos_svg/node_white.svg";
import sql_blk from "../../assets/logos_svg/sql_black.svg";
import sql_wht from "../../assets/logos_svg/sql_white.svg";
import postgres_blk from "../../assets/logos_svg/postgres_black.svg";
import postgres_wht from "../../assets/logos_svg/postgres_white.svg";
import jest_blk from "../../assets/logos_svg/jest_black.svg";
import jest_wht from "../../assets/logos_svg/jest_white.svg";

function TechSkills({ theme }) {
  const logos_blk = [
    html_blk,
    css_blk,
    js_blk,
    sql_blk,
    react_blk,
    node_blk,
    postgres_blk,
    jest_blk,
  ];
  const logos_wht = [
    html_wht,
    css_wht,
    js_wht,
    sql_wht,
    react_wht,
    node_wht,
    postgres_wht,
    jest_wht,
  ];

  const logos = theme === "light" ? logos_blk : logos_wht;

  return (
    <>
      <SkillsContainer>
        {logos.map((item, index) => {
          return <SkillLogo src={item} alt={`${item}`} key={index} />;
        })}
      </SkillsContainer>
    </>
  );
}

export default TechSkills;

const SkillsContainer = styled.div`
  width: fit-content;
`;

const SkillLogo = styled.img`
  width: 36px;
  height: 36px;

  ${mobile({ width: "30px", height: "30px" })};
`;
